module.exports = __webpack_public_path__ + "img/paquetes.70644e3c.jpg";